import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createSimpleStepItem } from "../../api/apiSimpleStepItems";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

export function useCreateSimpleStepItem() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: createItemMutate, isPending } = useMutation({
        mutationFn: createSimpleStepItem,
        onSuccess: (response) => {
            toast.success(response.message || "Created successfully");
            queryClient.invalidateQueries({ queryKey: ["simple-step-items"] });
            navigate("/simple-steps");
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create simple step item");
        },
    });

    return { createItemMutate, isPending };
}
